const theme = {
    "primaryColor": "rgba(242, 194, 0, 1)",
    "secondaryColor": "rgba(242, 194, 0, 0.2)",
    "backgroundColor": "rgba(255, 255, 255, 1)",
    "borderColor": "rgba(242, 194, 0, 1)",
    "hoverUnselectedBgColor": "rgba(242, 194, 0, 0.25)",
    "descriptionColor": "rgba(125, 125, 125, 1)",
    "underlineColor": "rgba(225, 225, 0, 1)",
    "linearGradient": "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 24%)"
};

export default theme;